module.exports = __webpack_public_path__ + "img/democode.7e4f3b79.png";